export const urlSocket = "https://senhai-connect-server.onrender.com/"
// https://senhai-connect-server.herokuapp.com/
// http://localhost:4000/
